export const TOOLTIP_POSITION = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
} as const;

export const TOOLTIP_ACTION_STATUS = {
  waiting: 'waiting',
  submitted: 'submitted',
} as const;

export const TOOLTIP_FADE_DELAY = 3000;
export const BUFFER_OFFSET = 10;
